<script setup lang="ts">
import type { PropType } from 'vue';

import { ROUTE_NAMES } from '~/constants/routes';
import { isAuction, type PlatformSaleItemEntity } from '~/types/sale.type';

// PROPS
const { sale } = defineProps({
    sale: { type: Object as PropType<PlatformSaleItemEntity>, required: true },
});

// COMPOSABLES
const { tt } = useTypedI18n();
const { data: authData } = useAuthUtils();
const route = useRoute();
const localePath = useLocalePath();
const { trackNegotiationGoToNegotiation } = useTracking();

// DATA
const isBuyer = computed(() => sale.sellerCompanyId !== authData.value?.user?.companyId);

const label = computed(() => tt(isAuction(sale) || isBuyer.value ? 'negotiation.goToNegotiation' : 'negotiation.showNegotiations'));

const routeTo = computed(() => ({
    name: isAuction(sale) ? ROUTE_NAMES.AUCTION_DETAIL_NEGOTIATION : ROUTE_NAMES.DIRECT_SALE_DETAIL_NEGOTIATION,
    params: route.params,
}));

// METHODS
const onClick = (): void => {
    trackNegotiationGoToNegotiation(isAuction(sale) || isBuyer.value ? 'go_negotiation' : 'show_negotiation');
};
</script>

<template>
    <UButton
        size="lg"
        color="neutral"
        variant="outline"
        :ui="buttonResponsiveSizeUi('lg', 'xl')"
        :label="label"
        block
        :to="localePath(routeTo)"
        @click="onClick"
    />
</template>
